import Revive from "~/models/revive/revive"
import {IFormSubmissionStepRevive} from "~/interfaces/reviveInterfaces"
import {ICompleter, IFileUpload, IFileUploadTemp, IFormSubmission, IGroup, IStepTrace} from "~/interfaces/formSubmissionEditInterfaces"

export default class FormSubmissionStepRevive extends Revive<IFormSubmissionStepRevive> implements IFormSubmissionStepRevive {
  client_id: string
  file_uploads: Array<IFileUpload>
  fileUploadsTemp: Array<IFileUploadTemp>
  id: string
  is_initial_submission: boolean
  workflow_step_id: string
  c_at: string
  completed_at: string
  is_complete: boolean
  started_at: string
  title: string
  u_at: string
  original_form_submission: Pick<IFormSubmission, "id" | "c_at"> | null
  completers: Array<ICompleter> | null
  completer_group: IGroup | null
  form_submission_steps: Array<IFormSubmissionStepRevive> | null
  is_revision_mode_enabled: boolean
  step_traces: Array<IStepTrace> | null

  static get displayName(): string {
    return 'FormSubmissionStepRevive'
  }
}